export default function (element, data) {
    window.addEventListener("load", (event) => {
        setTimeout(function() {
            element.querySelector(".fuzzy-overlay").classList.remove("active");
        }, 300)
    });

};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
